import { app } from '../app';
import { languages } from '../data/constants';

app.config(configureTranslate);
app.config(configureLocales);
app.run(sanitizeCookie);
app.run(initTranslate);
app.run(initLocales);

/** @ngInject */
function configureTranslate($translateProvider) {

    $translateProvider.useStaticFilesLoader({
        prefix: '',
        suffix: '',
        fileMap: {
            de: require('../i18n/de.json'),
            en: require('../i18n/en.json'),
            es: require('../i18n/es.json'),
            fr: require('../i18n/fr.json'),
            ja: require('../i18n/ja.json'),
            pt: require('../i18n/pt.json'),
            zh: require('../i18n/zh.json'),
        }
    });

    $translateProvider.preferredLanguage('en');
    $translateProvider.useCookieStorage();
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
}

/** @ngInject */
function configureLocales(tmhDynamicLocaleProvider) {
    tmhDynamicLocaleProvider.useCookieStorage('NG_TRANSLATE_LANG_KEY');
}

/** @ngInject */
function sanitizeCookie($translate, $cookies) {
    // this is a workaround to handle a ghost bug. NG_TRANSLATE_LANG_KEY
    // cookie value was corrupt, and i18n/{corruptKey}.json could not be loaded.
    const NG_TRANSLATE_LANG_KEY = $cookies.get('NG_TRANSLATE_LANG_KEY');
    const supportedLangKeys = languages.map((lang) => lang.key);
    if (NG_TRANSLATE_LANG_KEY && !supportedLangKeys.includes(NG_TRANSLATE_LANG_KEY)) {
        $cookies.remove('NG_TRANSLATE_LANG_KEY');
        $translate.use('en');
    }
}

/** @ngInject */
function initTranslate($rootScope, $translate, tmhDynamicLocale) {
    $translate.onReady(languageLoaded);
    $rootScope.$on('$translateChangeSuccess', languageLoaded);

    function languageLoaded() {
        tmhDynamicLocale.set($translate.use());
        $rootScope.$broadcast('language-loaded');
    }
}

/** @ngInject */
function initLocales(tmhDynamicLocaleCache) {

    // Do not change this to a loop!
    // If you do something like require('angular-i18n/' + locale)
    // webpack will pack all locales, because it cannot
    // understand what you want to `require` at compile-time.
    require('angular-i18n/de'); cache('de');
    require('angular-i18n/en'); cache('en');
    require('angular-i18n/es'); cache('es');
    require('angular-i18n/fr'); cache('fr');
    require('angular-i18n/ja'); cache('ja');
    require('angular-i18n/pt'); cache('pt');
    require('angular-i18n/zh'); cache('zh');

    function cache(key) {
        tmhDynamicLocaleCache.put(key, angular.injector(['ngLocale']).get('$locale'));
    }
}



// WEBPACK FOOTER //
// ./src/portal/config/i18n.config.js